import {
  Claim,
  ClaimStatus,
  Procedure,
  ProcedureSource,
  ProcedureStatus,
  StatusTypes,
} from '@dataTypes/claimFeature.types'

export const initialClaim: Claim = {
  id: 'CLM0006',
  createdAt: '2025-02-15',
  updatedAt: '2025-02-15',
  patientId: '',
  patientName: '',
  patientDateOfBirth: '',
  patientGender: '',
  relationToSubscriber: '',
  subscriberId: '',
  subscriberName: '',
  subscriberDateOfBirth: '',
  providerEntityType: 'Individual',
  providerId: '',
  providerName: '',
  providerTaxId: '',
  clinicName: 'Smile Dental Clinic',
  groupName: 'Premium Plan',
  groupId: 'GRP001',
  insurancePlanId: '',
  insuranceProviderId: '',
  insuranceProvider: '',
  insuranceCarrierId: '',
  insuranceCarrier: '',
  insuranceCarrierPayerCode: '',
  status: ClaimStatus.UnderReview,
  checkStatus: StatusTypes.Cleared,
  checkNumber: 'BN456789123',
  claimSource: 0,
  claimType: 'Claims',
  claimForm: 'ADA 2025',
  claimAmount: '450.00',
  amountPaid: '200.00',
  procedures: [],
  attachments: [],
  photo:
    'https://cdn.prod.website-files.com/6365d860c7b7a7191055eb8a/65a74e794636d55ddc197dfe_Blake%20Riley.jpg',
  validity: '2025-12-31',

  appointments: [
    {
      id: 'A001',
      date: '2025-02-20',
      type: 'Checkup',
      provider: 'Dr. Smith',
    },
    {
      id: 'A002',
      date: '2025-03-05',
      type: 'Consultation',
      provider: 'Dr. Johnson',
    },
  ],

  treatmentPlans: [
    {
      id: 'T001',
      name: 'Root Canal Treatment',
      provider: 'Dr. Smith',
      date: '2025-03-10',
      status: 'Planned',
    },
    {
      id: 'T002',
      name: 'Braces Installation',
      provider: 'Dr. Johnson',
      date: '2025-04-15',
      status: 'Ongoing',
    },
  ],

  insurancePayments: [
    {
      id: 'pay-001',
      checkNumber: 'CHK123456',
      bankName: 'MYBANK',
      depositDate: '2024-02-01',
      eobNumber: 'EOB654321',
    },
  ],
  entityType: 'Individual',
  modeOfPayment: 'Wire',
  paymentDate: '2025-03-10',
}

export const appointmentProcedures: Record<string, Procedure[]> = {
  A001: [
    {
      procedureId: 'P001',
      procedureName: 'Teeth Cleaning',
      procedureCode: 'D1110',
      procedureDate: '2025-02-20',
      provider: 'Dr. Smith',
      providerFirstName: 'John',
      providerLastName: 'Doe',
      coverage: '80%',
      amount: '150.00',
      clinic_fee: '20.00',
      insurance_plan_id: 'IP001',
      allowed_amount: 100,
      write_off: 50,
      estimated_insurance_pay: 50,
      estimated_patient_resp: 50,
      toothNumber: 'N/A',
      toothSurface: 'FM',
      status: ProcedureStatus.Unclaimed,
      source: ProcedureSource.Appointment,
      procedureNotes: [],
      procedureAttachments: [],
      patientName: 'Blake Riley',
    },
    {
      procedureId: 'P005',
      procedureName: 'Fluoride Treatment',
      procedureCode: 'D1206',
      procedureDate: '2025-02-20',
      provider: 'Dr. Smith',
      providerFirstName: 'John',
      providerLastName: 'Doe',
      coverage: '85%',
      amount: '80.00',
      clinic_fee: '20.00',
      insurance_plan_id: 'IP001',
      allowed_amount: 100,
      write_off: 50,
      estimated_insurance_pay: 50,
      estimated_patient_resp: 50,
      toothNumber: 'N/A',
      toothSurface: 'FM',
      status: ProcedureStatus.Unclaimed,
      source: ProcedureSource.Appointment,
      procedureNotes: [],
      procedureAttachments: [],
      patientName: 'Blake Riley',
    },
  ],
  A002: [
    {
      procedureId: 'P002',
      procedureName: 'Cavity Filling',
      procedureCode: 'D2140',
      procedureDate: '2025-03-05',
      provider: 'Dr. Johnson',
      providerFirstName: 'Jane',
      providerLastName: 'Smith',
      coverage: '85%',
      amount: '200.00',
      clinic_fee: '20.00',
      insurance_plan_id: 'IP001',
      allowed_amount: 100,
      write_off: 50,
      estimated_insurance_pay: 50,
      estimated_patient_resp: 50,
      toothNumber: '30',
      toothSurface: 'MO',
      status: ProcedureStatus.Unclaimed,
      source: ProcedureSource.Appointment,
      procedureNotes: [],
      procedureAttachments: [],
      patientName: 'Blake Riley',
    },
    {
      procedureId: 'P006',
      procedureName: 'X-Ray',
      procedureCode: 'D0220',
      procedureDate: '2025-03-05',
      provider: 'Dr. Johnson',
      providerFirstName: 'Jane',
      providerLastName: 'Smith',
      coverage: '90%',
      amount: '100.00',
      clinic_fee: '20.00',
      insurance_plan_id: 'IP001',
      allowed_amount: 100,
      write_off: 50,
      estimated_insurance_pay: 50,
      estimated_patient_resp: 50,
      toothNumber: 'N/A',
      toothSurface: 'N/A',
      status: ProcedureStatus.Unclaimed,
      source: ProcedureSource.Appointment,
      procedureNotes: [],
      procedureAttachments: [],
      patientName: 'Blake Riley',
    },
  ],
}

export const treatmentPlanProcedures: Record<string, Procedure[]> = {
  T001: [
    {
      procedureId: 'P003',
      procedureName: 'Root Canal Therapy',
      procedureCode: 'D3310',
      procedureDate: '2025-03-10',
      provider: 'Dr. Smith',
      providerFirstName: 'John',
      providerLastName: 'Doe',
      coverage: '90%',
      amount: '700.00',
      clinic_fee: '20.00',
      insurance_plan_id: 'IP001',
      allowed_amount: 100,
      write_off: 50,
      estimated_insurance_pay: 50,
      estimated_patient_resp: 50,
      toothNumber: '19',
      toothSurface: 'MOD',
      status: ProcedureStatus.Unclaimed,
      source: ProcedureSource.TreatmentPlan,
      procedureNotes: [],
      procedureAttachments: [],
      patientName: 'Blake Riley',
    },
    {
      procedureId: 'P007',
      procedureName: 'Post & Core Build-Up',
      procedureCode: 'D2950',
      procedureDate: '2025-03-10',
      provider: 'Dr. Smith',
      providerFirstName: 'John',
      providerLastName: 'Doe',
      coverage: '80%',
      amount: '250.00',
      clinic_fee: '20.00',
      insurance_plan_id: 'IP001',
      allowed_amount: 100,
      write_off: 50,
      estimated_insurance_pay: 50,
      estimated_patient_resp: 50,
      toothNumber: '19',
      toothSurface: 'MOD',
      status: ProcedureStatus.Unclaimed,
      source: ProcedureSource.TreatmentPlan,
      procedureNotes: [],
      procedureAttachments: [],
      patientName: 'Blake Riley',
    },
  ],
  T002: [
    {
      procedureId: 'P004',
      procedureName: 'Braces Installation',
      procedureCode: 'D8080',
      procedureDate: '2025-04-15',
      provider: 'Dr. Johnson',
      providerFirstName: 'Emily',
      providerLastName: 'Clark',
      coverage: '75%',
      amount: '2000.00',
      clinic_fee: '20.00',
      insurance_plan_id: 'IP001',
      allowed_amount: 100,
      write_off: 50,
      estimated_insurance_pay: 50,
      estimated_patient_resp: 50,
      toothNumber: 'N/A',
      toothSurface: 'FM',
      status: ProcedureStatus.Unclaimed,
      source: ProcedureSource.TreatmentPlan,
      procedureNotes: [],
      procedureAttachments: [],
      patientName: 'Blake Riley',
    },
    {
      procedureId: 'P008',
      procedureName: 'Retainers Placement',
      procedureCode: 'D8680',
      procedureDate: '2025-04-15',
      provider: 'Dr. Johnson',
      providerFirstName: 'Emily',
      providerLastName: 'Clark',
      coverage: '80%',
      amount: '500.00',
      clinic_fee: '20.00',
      insurance_plan_id: 'IP001',
      allowed_amount: 100,
      write_off: 50,
      estimated_insurance_pay: 50,
      estimated_patient_resp: 50,
      toothNumber: 'N/A',
      toothSurface: 'FM',
      status: ProcedureStatus.Unclaimed,
      source: ProcedureSource.TreatmentPlan,
      procedureNotes: [],
      procedureAttachments: [],
      patientName: 'Blake Riley',
    },
  ],
}
